// Shown when the server refuses a new/activated client with
// 403 client_limit_reached (see functions/_lib/plan-limits.ts). The message
// itself is written server-side (plan-aware); this adds the way out.
import { ArrowUpCircle } from "lucide-react";
import { ApiError } from "../lib/api";

export interface PlanLimitInfo { message: string; contact: string | null }

/** Returns limit details if this error is a plan-limit refusal, else null. */
export function planLimitFrom(e: unknown): PlanLimitInfo | null {
  if (!(e instanceof ApiError) || e.body?.error !== "client_limit_reached") return null;
  const contact = typeof e.body?.upgrade?.contact_email === "string" ? e.body.upgrade.contact_email : null;
  return { message: e.body?.message || "You've reached your plan's client limit.", contact };
}

export function PlanLimitNotice({ info }: { info: PlanLimitInfo }) {
  return (
    <div role="alert" style={{
      display: "flex", gap: 12, alignItems: "flex-start", padding: "14px 16px", margin: "10px 0",
      borderRadius: "var(--ne-radius)", border: "1px solid var(--ne-warning-border)", background: "var(--ne-warning-bg)",
    }}>
      <ArrowUpCircle size={20} aria-hidden="true" style={{ color: "var(--ne-red-bright)", flex: "none", marginTop: 1 }} />
      <div>
        <strong style={{ display: "block", marginBottom: 4 }}>Plan limit reached</strong>
        <span style={{ color: "var(--ne-warning-text)" }}>{info.message}</span>
        {info.contact && (
          <div style={{ marginTop: 8 }}>
            <a className="primary-button" style={{ display: "inline-flex", padding: "6px 12px", fontSize: 13 }}
               href={`mailto:${info.contact}?subject=${encodeURIComponent("Upgrade my Dispute Manager plan")}`}>
              Contact us to upgrade
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
